import { render, staticRenderFns } from "./EmployeeAwayAssignment.vue?vue&type=template&id=2e5e3cc1&scoped=true&"
import script from "./EmployeeAwayAssignment.vue?vue&type=script&lang=js&"
export * from "./EmployeeAwayAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5e3cc1",
  null
  
)

export default component.exports